/* src/app/views/visit/visit-detail/visit-detail.component.css */
/*# sourceMappingURL=visit-detail.component.css.map */
